import { validateAndProcessingXlsx } from '../lib/file';
import { actionTypes } from './config';

export const houseChangeAction = (value) => ({
  type: actionTypes.house_change,
  payload: value,
});

export const accountTypeChangeAction = (value) => ({
  type: actionTypes.account_type_change,
  payload: value,
});

export const importTypeChangeAction = (value) => ({
  type: actionTypes.import_type_change,
  payload: value,
});

export const fileChangeAsyncAction = (data) => async (dispatch) => {
  dispatch({ type: actionTypes.file_upload_started });

  const result = await validateAndProcessingXlsx(data);
  dispatch({ type: actionTypes.file_change, payload: result });
};

export const sheetChangeAction = (value) => ({
  type: actionTypes.sheet_change,
  payload: value,
});

export const dataStartRowChangeAction = (value) => ({
  type: actionTypes.data_start_row_change,
  payload: value,
});

export const companyChangeAction = () => ({ type: actionTypes.company_change });

export const stepChangeAction = (step) => ({
  type: actionTypes.step_change,
  payload: step,
});

export const settingFieldChangeAction = ({ name, value }) => ({
  type: actionTypes.setting_field_change,
  payload: { name, value },
});

export const goToPreviewAction = (data) => ({
  type: actionTypes.go_to_preview,
  payload: data,
});

export const addPreviewDataAction = (data) => ({
  type: actionTypes.add_preview_data,
  payload: data,
});

export const resetStateAction = () => ({ type: actionTypes.reset_state });

export const addResultData = (data) => ({
  type: actionTypes.add_result_data,
  payload: data,
});
